import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdicionaisEDescontosDetalharRoutingModule } from './adicionais-e-descontos-detalhar-routing.module';
import { AdicionaisEDescontosDetalharComponent } from './adicionais-e-descontos-detalhar.component';
import { FormsModule } from '@angular/forms';
import { MessagesModule } from 'primeng/messages';
import { DividerModule } from 'primeng/divider';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';


@NgModule({
  declarations: [
    AdicionaisEDescontosDetalharComponent
  ],
  imports: [
    CommonModule,
    AdicionaisEDescontosDetalharRoutingModule,
    FormsModule,
    MessagesModule,
    DividerModule,
    ButtonModule,
    ProgressSpinnerModule
  ]
})
export class AdicionaisEDescontosDetalharModule { }
